


import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { mapState, mapActions } from 'vuex'

export default {
components: {
TransferDom, Group,Toast,Loading
},
name: "App",
data() {
return {
transition:"",
}
},
methods: {
},
watch: {
$route(to, from) {












if (to.meta.index > from.meta.index) {
this.$nextTick(() => {
this.$refs.ddAudio.play();
})
} else {
this.$nextTick(() => {
this.$refs.ddAudioBack.play();
})
}

}
},
computed: {
...mapState({
isLoading: state => state.vux.isLoading,
direction: state => state.vux.direction
}),
}
};



// WEBPACK FOOTER //
// ./src/App.vue